export const QUERY_KEYS = {
  getHostCompanies: 'get-host-companies',
  getUniversities: 'get-universities',
  getUniversityStatuses: 'get-university-statuses',
  getImportHistories: 'get-import-histories',
  getParticipantDocuments: 'get-participant-documents',
  getProgramDocuments: 'get-program-documents',
  getProgramDocumentAnswers: 'get-program-document-answers',
  getSubmissionDocuments: 'get-submission-documents',
  getSubmissionFlightInfos: 'get-submission-flight-infos',
  getRules: 'get-rules',
  getStages: 'get-stages',
  getSavedSections: 'get-saved-sections',
  getInfiniteSavedSections: 'get-infinite-saved-sections',
  getProgramSections: 'get-program-sections',
  getExports: 'get-exports',
  getStagesRules: 'get-stages-rules',
  getPartners: 'get-partners',
  getMemberships: 'get-memberships',
  getUsers: 'get-users',
  getMyBankInfos: 'get-my-bank-infos',
  getMe: 'get-me',
  getUser: 'get-user',
  getStudents: 'get-students',
  getInfiniteStudents: 'get-infinite-students',
  getStudent: 'get-student',
  getPrograms: 'get-programs',
  getInfinitePrograms: 'get-infinite-programs',
  getProgram: 'get-program',
  getProgramFields: 'get-program-fields',
  getSubmissions: 'get-submissions',
  submissionDates: 'submission-dates',
  getSubmission: 'get-submission',
  getParticipantSubmissions: 'get-participant-submissions',
  getAllParticipants: 'get-all-participants',
  getSubmissionQuestions: 'get-submission-questions',
  getOrganizationMembers: 'get-organization-members',
  getOrganization: 'get-organization',
  getOrganizationById: 'get-organization-byId',
  getStagesProgress: 'get-stages-progress',
  getPlacements: 'get-placements',
  getPlacementSkills: 'get-placement-skills',
  getPlacementHostCompanies: 'get-placement-host-companies',
  getPlacementSponsors: 'get-placement-sponsors',
  getInfinitePlacementSponsors: 'get-infinite-placement-sponsors',
  getPlacementApplications: 'get-placement-applications',
  getPlacement: 'get-placement',
  getParticipants: 'get-participants',
  getInfiniteParticipants: 'get-infinite-participants',
  getAssignedPlacements: 'get-assigned-placements',
  getCompany: 'get-company',
  getProgramReminders: 'get-program-reminders',
  getReminders: 'get-reminders',
  getReminderDashboardStats: 'get-reminder-dashboard-stats',
  getReminderDashboardPerformance: 'get-reminder-dashboard-performance',
  getReminderDashboardSummary: 'get-reminder-dashboard-summary',
  getRemindersLogs: 'get-reminders-logs',
  getReminderTemplates: 'get-reminder-templates',
  getInterviewers: 'get-interviewers',
  getAppointments: 'get-appointments',
  getAppointmentTemplates: 'get-appointment-templates',
  getMeetingNotes: 'get-meeting-notes',
  getAppointmentLogs: 'get-appointment-logs',
  getCalendlyTypes: 'get-calendly-types',
  getInfiniteCalendlyTypes: 'get-infinite-calendly-types',
  getLeadPrograms: 'get-lead-programs',
  getLeadById: 'get-lead-byId',
  getUserById: 'get-user-byId',
  getLabels: 'get-labels',
  getInfiniteLabels: 'get-infinite-labels',
  getBankInfo: 'get-bank-info',
  getEWallet: 'get-ewallet',
  getReferList: 'get-refer-list',
  getInfiniteReferList: 'get-infinite-refer-list',
  getPlansList: 'get-plans-list',
  getStatusesList: 'get-statuses-list',
  getParticipantsPlacementApplications:
    'get-participants-placement-applications',
  getLocales: 'get-locales',
  getTimezones: 'get-timezones',
  getMembers: 'getMembers',
  getMember: 'getMember',
  getCurrentMember: 'getCurrentMember',
  getMemberContactInfos: 'getMemberContactInfos',
  getMemberContactInfo: 'getMemberContactInfo',
  getMemberDocuments: 'getMemberDocuments',
  getMemberDocument: 'getMemberDocument',
  getMemberEmergencyContacts: 'getMemberEmergencyContacts',
  getMemberEmergencyContact: 'getMemberEmergencyContact',
  getMemberAddresses: 'getMemberAddresses',
  getMemberAddress: 'getMemberAddress',
  getMemberBankAccounts: 'getMemberBankAccounts',
  getMemberBankAccount: 'getMemberBankAccount',
  getMyMemberProfile: 'get-my-member-profile',
  getRoles: 'get-roles',
  getRole: 'get-role',
  getPermissions: 'get-permissions',
  getCurrentSubscription: 'get-current-subscription',
  getProducts: 'get-products',
  getInvoices: 'get-invoices',
  getInvoice: 'get-invoice',
  getProgramTemplates: 'get-program-templates',
  getTaskComments: 'get-task-comments',
  getInfiniteTaskComments: 'get-infinite-task-comments',
  getLeads: 'get-leads',
  getLeadNotes: 'get-lead-notes',
  getLeadNotesStats: 'get-lead-notes-stats',
  getStudentNotes: 'get-student-notes',
  getSectionComments: 'get-section-comments',
  getNotes: 'get-notes',
  getLeadInterestedPrograms: 'get-lead-interested-programs',
  getViews: 'get-views',
  getView: 'get-view',
  getInfiniteViews: 'get-infinite-views',
  getTasks: 'get-tasks',
  getTaskStatuses: 'get-task-statuses',
  getTaskWorkspaces: 'get-task-workspaces',
  getWorkspaceMembers: 'get-workspace-members',
  getPayments: 'get-payments',
  getReceipts: 'get-receipts',
  getCustomFields: 'get-custom-fields',
  getCustomFieldValues: 'get-custom-field-values',
  getNotifications: 'notifications',
  getLeadStats: 'get-lead-stats',
  getProgramsStats: 'get-programs-stats',
  getLeadSFollowUps: 'get-leads-follow-ups',
  getTopPreformance: 'get-top-preformance',
  getLeadsNeedAttention: 'get-leads-need-attention',
  getEnglishLeveData: 'get-english-level-data',
  getLeadsByStatus: 'get-leads-by-status',
  getDashboardGenderData: 'get-dashboard-gender-data',
  getConversionRankData: 'get-conversion-rank-data',
  getNewLeadsOverTime: 'get-new-leads-over-time',
  getDshboardLeadsReferal: 'get-dshboard-leads-referal',
  getApplicationStatusBreakdown: 'get-application-status-breakdown',
  getPlacementStatusBreakdown: 'get-placement-status-breakdown',
  getStageBreakdown: 'get-stage-breakdown',
  getAccountingStats: 'get-accounting-stats',
  getParticipantReferral: 'get-participant-referral',
  getApplicationByProgram: 'get-application-by-program',
  getStageAvgTime: 'get-stage-avg-time',
  getProgramsTopPerformance: 'get-programs-top-performance',
  getProgramsUpcomingAppointments: 'get-programs-upcoming-appointments',
  getApplicationOvertime: 'get-application-overtime',
  getOrganizationPartners: 'get-organization-partners',
  getAuditLogs: 'get-audit-logs',
  getVisaInterviews: 'get-visa-interviews',
  getVisaInterviewLockStatus: 'get-visa-interview-lock-status',
  getVisaInterviewNotes: 'get-visa-interview-notes',
  getVisaResults: 'get-visa-results',
  getAnnouncements: 'get-announcements',
  getOrganizationBranding: 'get-organization-branding',
  resumes: 'resumes',
  resume: 'resume',
  resumeGeneralInfo: 'resume-general-info',
  resumeProfessionalInfo: 'resume-professional-info',
  resumeEducation: 'resume-education',
  resumeWorkExperience: 'resume-work-experience',
  resumeSkills: 'resume-skills',
  resumeLanguages: 'resume-languages',
  resumeCertificates: 'resume-certificates',
  getAnnouncementStats: 'get-announcement-stats',
  getAnnouncementDetailStats: 'get-announcement-detail-stats',
};
